import {Suspense, lazy, useState, useEffect} from 'react';

import {createSyncStoragePersister} from '@tanstack/query-sync-storage-persister';
import {QueryClient} from '@tanstack/react-query';
import {persistQueryClient} from '@tanstack/react-query-persist-client';

//initialize react-query provider client with defaults
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      retry: 0,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      networkMode: 'offlineFirst'
    },
    mutations: {
      retry: false,
      networkMode: 'offlineFirst'
    }
  }
});

//https://tanstack.com/query/v4/docs/devtools#devtools-in-production
const LazyReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
    default: d.ReactQueryDevtools
  }))
);

export const ReactQueryDevTools = () => {
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    // @ts-ignore
    window.toggleDevtools = () => setShowDevtools(true);
  }, []);

  return (
    <>
      {showDevtools && (
        <Suspense fallback={null}>
          <LazyReactQueryDevtools initialIsOpen />
        </Suspense>
      )}
    </>
  );
};

// @ts-ignore
export const toggleReactQueryDevTools = () => window.toggleDevtools();

export const PERSIST_QUOTING_CACHE_KEY = 'persist_quoting_cache_key';
export const persistQueries = (key: string) => {
  persistQueryClient({
    queryClient: queryClient,
    persister: createSyncStoragePersister({
      storage: window.sessionStorage,
      key
    }),
    maxAge: Infinity
  });
};
